import { Component, inject, Input } from '@angular/core';
import { ButtonModule } from "@primeng/button";
import { TranslatePipe } from "@ngx-translate/core";
import { BasicForm } from '@shared/components/classes/basic.form';
import { RentalContract } from '@modules/universal-billing/contract/contract.interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DepositPayment, DepositType } from '@modules/universal-billing/contract/contract.enums';
import { ContractService } from '@modules/universal-billing/contract/contract.service';
import { Observable } from 'rxjs';
import {
  ContractDepositFormComponent
} from '@modules/universal-billing/contract/components/contract-deposit-form/contract-deposit-form.component';

@Component({
  selector: 'app-contract-deposits-form',
  standalone: true,
  imports: [
    ButtonModule,
    TranslatePipe,
    ContractDepositFormComponent
  ],
  templateUrl: './contract-deposits-form.component.html',
  styleUrl: './contract-deposits-form.component.scss'
})
export class ContractDepositsFormComponent extends BasicForm<any>{

  @Input() contract: RentalContract;
  @Input() afterSuccess: Function;
  dateFields = ['depositDueDate'];

  form: FormGroup = new FormGroup({
    depositType: new FormControl(DepositType.NO_DEPOSIT, Validators.required),
    depositAmount: new FormControl(),
    depositDueDate: new FormControl(),
    depositPayment: new FormControl(DepositPayment.ONE_TIME_PAYMENT),
  });

  _defaultService: ContractService = inject(ContractService);

  isEdit = true;

  ngOnInit() {
    this.patchResponseData({...this.contract });
  }

  convertToRequestData(data: any): any {
    return super.convertToRequestData({ ...this.contract, ...data});
  }

  submitAction(data: any): Observable<any> {
    return this._defaultService.put(data, this.contract.id);
  }

  afterSuccessSubmit(res: any) {
    this.afterSuccess(res.data);
    super.afterSuccessSubmit(res);
  }
}
